//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  props: {
    opened: {
      type: Boolean
    },
    message: {
      type: String
    },
    position: {
      type: String
    },
    blocked: {
      type: Boolean
    }
  },
  watch: {
    opened: function (val) {
      if (val & !this.blocked) {
        setTimeout(this.close, 3000)
      }
    }
  },
  methods: {
    close: function () {
      this.$emit('closeDialog')
    }
  }
}

